import { AcceptableProviders } from "../@types/Auth";
import { getUrl, handleCallback } from "../services/external-auth";

export default function useExternalAuth() {
  function getRedirectURL(provider: AcceptableProviders): Promise<string> {
    return getUrl(provider);
  }

  function handleCallbackAuth(
    provider: AcceptableProviders,
    query: string
  ): Promise<boolean> {
    return handleCallback(provider, query);
  }

  return {
    getRedirectURL,
    handleCallbackAuth,
  };
}
